import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Container } from '../../components/layout/Container';
import { useLanguage } from '../../contexts/LanguageContext';
import {
    ServiceFeatureHighlightCard
} from '../../components/common';
import { ServiceContactModal } from '../../components/features/Service/ServiceContactModal';

const Services = () => {
    const { t } = useLanguage();
    const services = t('servicesData.services', { returnObjects: true });

    const [selectedService, setSelectedService] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleDetailsClick = (serviceId) => {
        const service = services.find(s => s.id === serviceId);
        if (service) {
            setSelectedService(service);
            setIsModalOpen(true);
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedService(null);
    };

    if (!Array.isArray(services)) return null;

    return (
        <main className="min-h-screen bg-gray-50">
            <PageHeader
                title={t('pages.services.title')}
                subtitle={t('pages.services.subtitle')}
            />

            <div className="py-12 sm:py-20">
                <Container>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 max-w-7xl mx-auto">
                        {services.map((service) => (
                            <ServiceFeatureHighlightCard
                                key={`feature-${service.id}`}
                                service={service}
                                onDetailsClick={handleDetailsClick}
                            />
                        ))}
                    </div>
                </Container>
            </div>

            <ServiceContactModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                serviceTitle={selectedService?.title}
            />
        </main>
    );
};

export default Services;
